import api from '../../utils/api';

export default {
  fetch: (query) => api.makeEndpoint('get', `organizations/${query}`),
};
